//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	//Fancybox
	$('fancybox').fancybox({
		protect: false,
		loop: false,
		margin: [40, 0],
		gutter: 12,
		keyboard: true, 
		arrows: true,
		infobar: false,
		toolbar: true,
		buttons: [
			"slideShow",
			'fullScreen',
			// 'thumbs',
			// 'share',
			// "download",
			// 'zoom',
			"close"
		],
		image: {
			preload: "auto"
		},

		afterLoad: function(instance, current) {
			var pixelRatio = window.devicePixelRatio || 1;

			if ( pixelRatio > 1.5 ) {
				current.width  = current.width  / pixelRatio;
				current.height = current.height / pixelRatio;
			}
		  }
	});
	//placerhorder mobile
	$("#id_2_549,#id_3_550,#id_3_551,#id_5_586,#id_5_585").on("input",function(){
		if($(this).val().length>0){
		$(this).addClass("full");
	}
		else{
		$(this).removeClass("full");
		}
	});

	
	/* tabs shortcode accordion */
	$('.toggle').click(function(e) {
		e.preventDefault();

	var $this = $(this);

	if ($this.next().hasClass('show')) {
		$this.next().removeClass('show');
		$this.next().slideUp(350);

	} else {
		$this.parent().parent().find('li .inner').removeClass('show');
		//$this.parent().parent().find('li .inner').slideUp(350);
		$this.next().toggleClass('show');
		$this.next().slideToggle(350);
	}

	var arrowAccordion = $this.parent();

	if (arrowAccordion.hasClass('showing-tab')) {
		arrowAccordion.removeClass('showing-tab');

	} else {
		arrowAccordion.addClass('showing-tab');
		arrowAccordion.addClass('showing-tab');
	}

	});


	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//scroll down click
	if(document.getElementsByClassName('scroll-down').length > 0){
		document.getElementsByClassName('scroll-down')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}
	// document.getElementsByClassName('planning-btn')[0].addEventListener('click', function(e){
	// 	e.preventDefault();
	// 	animateTo(this.getAttribute('href').split('#')[1]);
	// });

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		
		}
	});

	var specific_form = "";
	$('a.btn-360-tour, a.btn-rqst').click(function(){

		if( dataLayer ){
			specific_form = $( this ).parent().parent().parent().find( "h2" ).text() + " " + $( this ).parent().parent().parent().find( "h3" ).text();
			var path = document.URL.split("/")[3];
			var text = site_url + " - " + path + " - " + specific_form + " - " + $( "#form_id-586 input[name='subject']" ).val();
			//console.log(text);
			dataLayer.push( { "form_name": text } );
			dataLayer.push( { "data-title": text } );
		}

	})
	

	// $( ".element_clicked" ).on( "click", function(){

	// 	if( dataLayer ){
	// 		var path = document.URL.split("/")[3];
	// 		dataLayer.push( { "form_name": site_url + " - " + path + " - " + $( ".element" ).text() + " - " + $( "#form_id-586 input[name='subject']" ).val() } );
	// 	}

	// } )

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('internal')){
					// document.getElementById('header').classList.add('down');
					// document.getElementById('header').classList.remove('up');
					document.getElementById('header').classList.add('internal')
					
					
				}
			} else {
				
				
				// upscroll code
				// if(!document.getElementById('header').classList.contains('up')){
				// 	document.getElementById('header').classList.add('up');
				// 	document.getElementById('header').classList.remove('down');
				// 	document.getElementById('header').classList.remove('internal');
					
				// }
			}
		} else {
			if(document.getElementById('header').classList.contains('internal')){
				document.getElementById('header').classList.remove('internal');
				if(windowWidth > 600){
					//logoUrl = site_url + 'assets/svg/logo.svg';
					//document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				}
			}
			
			// if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			// 	document.getElementById('header').classList.remove('up');
			// 	document.getElementById('header').classList.remove('down');
			// 	if(document.getElementById('home') && windowWidth > 600) {
			// 		logoUrl = site_url + 'assets/svg/logo.svg';
			// 		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
			// 	}
			// }
			// if(!document.getElementById('home') && !document.getElementById('header').classList.contains('internal')){
				
			// 	document.getElementById('header').classList.add('internal');
			// }
		}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

